import { getToken } from '@/utils/auth';

function arrForEach(fakeArr, fn) {
    var i = void 0,
        item = void 0,
        result = void 0;
    var length = fakeArr.length || 0;
    for (i = 0; i < length; i++) {
        item = fakeArr[i];
        result = fn.call(fakeArr, item, i);
        if (result === false) {
            break;
        }
    }
}

export default function(files, updata, insert, error) {

    var formdata = new FormData();

    arrForEach(files, function(file) {
        formdata.append('token', getToken());
        formdata.append('file', files[0]);
        formdata.append('key', updata.key);
        formdata.append('size', files[0].size);
    });

    var xhr = new XMLHttpRequest();

    xhr.open('POST', updata.fileUploadUrl);

    // 监控 progress
    if (xhr.upload) {
        xhr.upload.onprogress = function(e) {
            var percent = e.loaded / e.total;
        };
    }

    // 返回数据
    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
            if (xhr.status < 200 || xhr.status >= 300) {
                error('上传错误！');
                return;
            }

            var result = xhr.responseText;

            try {
                result = JSON.parse(xhr.responseText).payload;
            } catch (ex) {
                error('上传错误！');
                return;
            }

            insert(updata.imagePreUrl + '?id=' + updata.key);
        }
    };

    xhr.send(formdata);
}


// WEBPACK FOOTER //
// ./src/utils/editorUpload.js